import FormTableRaw from "./FormTableRaw";

const FormTable = ({ data }) => {
  return (
    <div className='plt-table-wrapper'>
      <div className='plt-table-container'>
        <table className='plt-table'>
          <thead>
            <tr>
              <th className='plt-table-head'>Item</th>
              <th className='plt-table-head'>Name/token</th>
              <th className='plt-table-head'>Role</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((d) => (
              <FormTableRaw data={d} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FormTable;
